function ChangePasswordErrorHandler(response = {}) {
  if (!(response && response.data)) return;
  const { data = {} } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", errorCode } = error;

  if (statusCode === 400) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "senha-e-nova-senha-iguais",
          title: "Senha atual e nova senha estão iguais",
          message: `Você digitou uma nova senha igual a sua senha atual.`,
        },
      },
    };
  } else if (statusCode === 422) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "senha-atual-incorreta",
          title: "Senha incorreta",
          message: "A senha atual está incorreta. Tente novamente",
        },
      },
    };
  } else if (statusCode === 401) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "efetue o login novamente",
        },
      },
    };
  } else if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Erro ao alterar sua senha",
          message: "Verifique sua conexão com a internet",
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default ChangePasswordErrorHandler;
